import React, {useState, useEffect,useContext} from 'react';
import { RootStoreContext } from '../../stores/RootStore';
import { LecturerAttendanceList, LecturerAttendanceParam } from '../../models/Attendance';
import { ISelect } from '../../models/General';
import Select from "react-select";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import MonitoringPage from '../../utils/MonitoringPage';
import ExportButton from '../../utils/ExportButton';

const LecturerAttendanceListPage = () => {
    
    const rootStore = useContext(RootStoreContext);
    const { getLecturerAttendanceList } = rootStore.attendanceStore;
    const { getInstitution, getCareer, getSemester} = rootStore.commonStore; 
    const emplidVal =  window.localStorage.getItem('emplid'); 

    const [list, setList] = useState<LecturerAttendanceList[]>([]) 

    const [institution, setInstitution] = useState<ISelect[]>();
    const [institutionVal, setInstitutionVal] = useState<string>('');
    const [career, setCareer] = useState<ISelect[]>();
    const [careerVal, setCareerVal] = useState<string>('');
    const [semester, setSemester] = useState<ISelect[]>();
    const [semesterVal, setSemesterVal] = useState<string>('');
    const [date] = useState(new Date());
    const [dateVal, setDateVal] = useState();
    const [dateParam, setDateParam] = useState<string>('0');

    const [status, setStatus] =  useState("success") 
    const [message, setMessage] = useState("") 
    const [statusAlert, setStatusAlert] = useState(0) 
    const [btnExport, setBtnExport] = useState(true) 

    const [isLoading, setIsLoading] = useState(false)

    function handleInstitutionSelect(event: any) {
        setInstitutionVal(event.value);

        const careerData = getCareer(String(emplidVal), event.value);
        careerData.then(function(result) {
            setCareer(result);
        })

    };

    function handleCareerSelect(event: any) {
      
        setCareerVal(event.value);

        const semesterData = getSemester(institutionVal, event.value);
        semesterData.then(function(result) {
            setSemester(result);
        })

    };

    function handleSemesterSelect (event: any) {
        setSemesterVal(event.value)

        if(event.value!==""){
            setBtnExport(false)
        }
    };

    function handleDateChange (event:any){
        console.log(event)
        let dateFormatted
        if(event == null){
            dateFormatted = '0'
        }
        else{
            dateFormatted = moment(event).format('YYYYMMDD');
        }
        
        setDateVal(event)
        setDateParam(dateFormatted)
    }


    const param: LecturerAttendanceParam = {
        INSTITUTION: String(institutionVal),
        ACAD_CAREER: String(careerVal),
        STRM: String(semesterVal),
        DATE:String(dateParam)
    };

    function loadData()
    {
        console.log("load data")
        getLecturerAttendanceList(param).then(function(response) {
            setList(response)
            setIsLoading(false)
        })  
        .catch(() => {
            setStatusAlert(1)
            setMessage("Unable to fetch data")
            setStatus("danger")
            setIsLoading(false);
        });
    }

    const columns = [
        {title: "ID", field: "EMPLID"},
        {title: "Name", field: "NAME_DISPLAY",},
        {title: "Course Name", field: "MATAKULIAH"},
        {title: "Class", field: "CLASS_SECTION"},
        {title: "Meeting Number", field: "CLASS_MTG_NBR"},
        {title: "Course Schedule", field: "CLASS_ATTEND_DT_STR"},
        {title: "Reschedule", field: "RESCHEDULE_DATE"},
        {title: "Course Schedule Sort", field: "CLASS_ATTEND_DT_SORT",defaultSort:"desc", hidden:true},
    ]

    useEffect(() => {

        if(institutionVal !== '' && semesterVal !== '' && careerVal !== '' ){
            setIsLoading(true);
        }

        const institutionData = getInstitution(String(emplidVal));
        institutionData.then(function(result) {
            setInstitution(result);
        })

        loadData()

    },[institutionVal, semesterVal,careerVal,dateParam])

    return (
        <React.Fragment>
           
           <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Lecturer Absence</h1>
                        </div>
                    </div>
                </div>
            </div>
            

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Institution</label>
                                                <Select
                                                    name="institution"
                                                    placeholder="Choose Institution"
                                                    options={institution}
                                                    onChange={handleInstitutionSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Career</label>
                                                <Select
                                                    name="career"
                                                    placeholder="Choose Career"
                                                    options={career}
                                                    onChange={handleCareerSelect}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Semester</label>
                                                <Select
                                                    name="semester"
                                                    placeholder="Choose Semester"
                                                    options={semester}
                                                    onChange={handleSemesterSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label>Date</label>
                                                <DatePicker
                                                    selected={dateVal}
                                                    openToDate={date}
                                                    onChange={handleDateChange} //only when value has changed
                                                    dateFormat="dd MMMM yyyy"
                                                 
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-1">
                                            <ExportButton
                                                showBtnExport={btnExport}
                                                setIsLoading={setIsLoading}
                                                apiURL={`${process.env.REACT_APP_API_URL}/academic/attendance/export-lecturer/${institutionVal}/${careerVal}/${semesterVal}/${dateParam}`}
                                                filename={"Lecturer_Attendance_Recap.xls"}
                                            ></ExportButton>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MonitoringPage 
                        list={list} 
                        columns={columns} 
                        status={status} 
                        message={message} 
                        tableName={"Lecturer List"}
                        tableMessage={"*this page only displays data H-1 and before"}
                        isLoading={isLoading}
                        statusAlert={statusAlert}
                        setStatusAlert={setStatusAlert}
                    ></MonitoringPage>

                </div>
            </section>
            
        </React.Fragment>
    );
}

export default LecturerAttendanceListPage;